// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"components--next-sr-only--sMICn4I","widthFull":"components--widthFull--1XEFHEd","editableDuration":"components--editableDuration--1xPH9f4"};